// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3r98C","content":"styles_content__2Oo7K","marquee":"styles_marquee__2n5hH"};